export default __webpack_public_path__ + "static/media/logo2.33fb41cf.svg";